var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99782 3.9656e-06C7.75732 -0.00344182 10.0006 2.23914 10 5.00047C9.99937 7.76211 7.75482 10.005 4.99657 9.99999C2.23644 9.99498 0.00658017 7.76587 1.4392e-05 5.00517C-0.00655138 2.2476 2.23425 0.00344975 4.99782 3.9656e-06ZM9.00356 5.00141C9.00544 2.79955 7.20017 0.993957 4.99844 0.996776C2.79766 0.999282 1.00677 2.78765 0.996449 4.99295C0.986444 7.18948 2.78859 8.99695 4.99563 9.00385C7.1936 9.01074 9.00138 7.20546 9.00325 5.00172L9.00356 5.00141Z",
    fill: "#FF5757"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50261 4.23771C4.50261 3.81983 4.49854 3.40163 4.50417 2.98407C4.50761 2.72438 4.69614 2.53016 4.95627 2.50072C5.18701 2.4744 5.41494 2.63103 5.47934 2.86315C5.49185 2.90763 5.49717 2.95556 5.49717 3.00192C5.4981 3.83392 5.49967 4.66592 5.49717 5.49792C5.49623 5.75166 5.33365 5.94337 5.09572 5.98942C4.86623 6.0339 4.63768 5.92144 4.54888 5.70686C4.5173 5.63012 4.50511 5.54084 4.50417 5.45689C4.49979 5.0506 4.5023 4.64462 4.5023 4.23833H4.50323L4.50261 4.23771Z",
    fill: "#FF5757"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.49748 6.99528C5.49998 7.28002 5.29175 7.49021 5.00473 7.49241C4.71709 7.4946 4.50417 7.28785 4.50261 7.00436C4.50104 6.72556 4.71865 6.50347 4.99535 6.50096C5.27205 6.49877 5.49467 6.71773 5.49717 6.99496L5.49748 6.99528Z",
    fill: "#FF5757"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamationIcon);
export default __webpack_public_path__ + "static/media/exclamation-icon.3901f41d21a310e99c9ee2747a4505cc.svg";
export { ForwardRef as ReactComponent };